import React, { useEffect } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { setTrendingPopularSearches } from "../../actionCreators/boostCommerceAC"
import PopularBags from "./PopularBags"
import TrendingItems from "./TrendingItems"
import { sendGroupBySearchEvent } from "../helpers"

const SearchMenu = React.memo((props) => {
    const {trendingSearches, popularBags, searchDesignersCollections, searchTopMatches, plpTotalSearchProducts} = useSelector((state) => state.shopifyReducer, shallowEqual);
    const {useGroupByApi, isInternational, isUsdInternational} = useSelector((state) => ({
        useGroupByApi: state.appReducer.useGroupByApi,
        isInternational: state.appReducer.isInternational,
        isUsdInternational: state.appReducer.isUsdInternational
    }), shallowEqual);
    const {mobile, top_promo_banner_not_visible, inputFocused, searchBarRef, searchValue} = props;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setTrendingPopularSearches(mobile));
    }, [mobile]);


    useEffect(() => {
        const nonUsd = isInternational ? !isUsdInternational : false;
        sendGroupBySearchEvent(searchValue, searchTopMatches, useGroupByApi, nonUsd);
    }, [searchTopMatches]);

    if (!inputFocused) return null;

    return (
        <div className={`search-menu ${top_promo_banner_not_visible ? '' : 'with-top-banner'}`}>
            <div className="search-menu__left">
                <h4 className="search-menu__title search-menu__title--left">Trending Searches</h4>
                <TrendingItems trendingSearches={searchDesignersCollections.length ? searchDesignersCollections : trendingSearches}/>
            </div>
            <div className="search-menu__right">
                <h4 className="search-menu__title search-menu__title--right">
                    {searchTopMatches.length ? 'Top Matches' : 'Popular Bags'}
                </h4>
                <PopularBags popularBags={searchTopMatches.length ? searchTopMatches : popularBags} />
                <a className="search-menu__view-all-bags"
                   onClick={() => searchBarRef.current.submit()}>
                    {`View all ${plpTotalSearchProducts ? plpTotalSearchProducts + ' ' : ''}items`}
                </a>
            </div>
        </div>
    )
})

export default SearchMenu;